import { Building2 } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { hospitalDashboardData } from "../../data/hospitalDashboard";
import type { HospitalDashboardViewData } from "../../api/mapHospitalDashboard";

function formatAmount(value: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value);
}

export function HospitalTopClientsCard({
  data = hospitalDashboardData,
}: {
  data?: HospitalDashboardViewData;
}) {
  const { t } = useTranslation();
  const labels = t.safecheck.dashboard.hospitalBoard.topClients;

  return (
    <div className="theme-card overflow-hidden">
      <div className="flex items-center gap-3 border-b border-border px-5 py-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-soft">
          <Building2 size={18} className="text-primary" />
        </div>
        <h3 className="text-sm font-semibold text-foreground">{labels.title}</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="safecheck-table w-full min-w-[640px]">
          <thead>
            <tr className="border-b border-border bg-card-muted/50">
              <th className="px-5 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-muted">
                {labels.columns.company}
              </th>
              <th className="px-5 py-3 text-center text-[11px] font-semibold uppercase tracking-wide text-muted">
                {labels.columns.invoices}
              </th>
              <th className="px-5 py-3 text-right text-[11px] font-semibold uppercase tracking-wide text-muted">
                {labels.columns.totalAmount}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.topClients.map((client) => (
              <tr key={client.rank} className="border-b border-border last:border-0">
                <td className="px-5 py-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-orange-100 text-xs font-bold text-orange-600">
                      {client.rank}
                    </span>
                    <span className="text-sm text-foreground">{client.company}</span>
                  </div>
                </td>
                <td className="px-5 py-4 text-center text-sm font-medium text-foreground">
                  {client.invoiceCount}
                </td>
                <td className="px-5 py-4 text-right text-sm font-semibold text-foreground">
                  {formatAmount(client.totalAmount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
